import { render } from "./UserInterface.vue?vue&type=template&id=24cdb249&ts=true"
import script from "./UserInterface.vue?vue&type=script&lang=ts"
export * from "./UserInterface.vue?vue&type=script&lang=ts"

import "./UserInterface.vue?vue&type=style&index=0&id=24cdb249&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__